import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import styled from "styled-components";

const StatusTag = styled.span`
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: ${({ $status }) =>
    $status === "pending"
      ? "var(--color-status-pending-bg, #d6d6d6)"
      : $status === "on_progress"
        ? "var(--color-status-in-progress-bg, #d89e201a)"
        : $status === "completed"
          ? "var(--color-status-completed-bg, #05cd991a)"
          : "var(--color-status-unknown-bg, #ff4d4f)"};

  color: ${({ $status }) =>
    $status === "pending"
      ? "var(--color-status-pending-text, #6a6a6a)"
      : $status === "on_progress"
        ? "var(--color-status-in-progress-text, #e39c02)"
        : $status === "completed"
          ? "var(--color-status-completed-text, #01b574)"
          : "var(--color-status-unknown-text, #ffffff)"};
`;

export const StatusTagComponent = ({ status }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case "pendiente":
        return <ClockCircleOutlined />;
      case "en-proceso":
        return <SyncOutlined spin />;
      case "completado":
        return <CheckCircleOutlined />;
      default:
        return null;
    }
  };

  return (
    <StatusTag $status={status}>
      {getStatusIcon(status)}
      <span>
        {status === "pending"
          ? "Pendiente"
          : status === "on_progress"
            ? "En Proceso"
            : status === "completed"
              ? "Completado"
              : "Sin estatus"}
      </span>
    </StatusTag>
  );
};
